
class AcaoEnviarConsultaCliente {
  makeFormFields(values) {
    return {
      emailDe: values?.emailDe || '',
      emailPara: values?.emailPara || '',
      emailCopia: values?.emailCopia || '',
      respostaPara: values?.respostaPara || '',
      assunto: values?.assunto || '',
      anexos: values?.anexos || [],
      texto: values?.texto || '',
      nomeAdvogado: values?.nomeAdvogado || '',
      emailAdvogado: values?.emailAdvogado || '',
    };
  }

  makeErrorFields() {
    return {
      emailDe: {
        error: false,
        errorMessage: '',
      },
      emailPara: {
        error: false,
        errorMessage: '',
      },
      emailCopia: {
        error: false,
        errorMessage: '',
      },
      respostaPara: {
        error: false,
        errorMessage: '',
      },
      assunto: {
        error: false,
        errorMessage: '',
      },
      nomeAdvogado: {
        error: false,
        errorMessage: '',
      },
      emailAdvogado: {
        error: false,
        errorMessage: '',
      },
      anexos: {
        error: false,
        errorMessage: '',
      },
      texto: {
        error: false,
        errorMessage: '',
      },
    };
  }
}


export const acaoEnviarConsultaClienteController = new AcaoEnviarConsultaCliente();
